import { t } from "../i18n.ts";
import { Icon, type IconName } from "../icons.tsx";

// Fixed meaning of colours and icons across the application (prototype: media colours --m-*).

const MEDIA: Record<string, { icon: IconName; color: string }> = {
  el: { icon: "bolt", color: "var(--m-el)" },
  gas: { icon: "flame", color: "var(--m-gas)" },
  water: { icon: "drop", color: "var(--m-water)" },
  temp: { icon: "thermo", color: "var(--m-temp)" },
  pv: { icon: "sun", color: "var(--m-pv)" },
  bess: { icon: "battery", color: "var(--m-bess)" },
  air: { icon: "air", color: "var(--m-air)" },
  humidity: { icon: "drop", color: "var(--m-hum)" },
  light: { icon: "sun", color: "var(--m-light)" },
  pressure: { icon: "gauge", color: "var(--m-press)" },
  wind: { icon: "air", color: "var(--m-wind)" },
};

export const MEDIA_IDS = Object.keys(MEDIA);

export function mediumColor(medium: string): string {
  return MEDIA[medium]?.color ?? "var(--accent)";
}

export function MediumBadge(props: { medium: string }) {
  const m = () =>
    MEDIA[props.medium] ?? {
      icon: "toggle" as IconName,
      color: "var(--accent)",
    };
  return (
    <span
      class="med"
      style={{ background: m().color }}
      title={t(`medium.${props.medium}`)}
    >
      <Icon name={m().icon} />
    </span>
  );
}

const NODE_ICONS: Record<string, IconName> = {
  site: "site",
  building: "building",
  floor: "floor",
  room: "room",
  zone: "zone",
  line: "line",
  machine: "machine",
  source: "sun",
  storage: "battery",
  home: "home",
  garage: "garage",
};

export const NODE_KINDS = Object.keys(NODE_ICONS);

export function NodeKindIcon(props: { kind: string }) {
  return <Icon name={NODE_ICONS[props.kind] ?? "folder"} />;
}

/** Device categories (backend DeviceCategories) with their icon and the medium colour they read as. */
const CATEGORIES: Record<string, { icon: IconName; color: string }> = {
  energy: { icon: "bolt", color: "var(--m-el)" },
  switch: { icon: "toggle", color: "var(--accent)" },
  lighting: { icon: "spark", color: "var(--m-el)" },
  climate: { icon: "thermo", color: "var(--m-temp)" },
  heating: { icon: "flame", color: "var(--m-gas)" },
  blind: { icon: "expand", color: "var(--m-air)" },
  gate: { icon: "garage", color: "var(--m-air)" },
  security: { icon: "alert", color: "var(--crit)" },
  button: { icon: "target", color: "var(--accent)" },
  camera: { icon: "search", color: "var(--m-air)" },
  measurement: { icon: "gauge", color: "var(--m-water)" },
  other: { icon: "folder", color: "var(--faint)" },
};

/** Display order of categories, as in the backend. */
export const CATEGORY_ORDER = Object.keys(CATEGORIES);

export function categoryRank(category: string): number {
  const i = CATEGORY_ORDER.indexOf(category);
  return i < 0 ? CATEGORY_ORDER.length : i;
}

export function CategoryBadge(props: { category: string }) {
  const c = () => CATEGORIES[props.category] ?? CATEGORIES["other"]!;
  return (
    <span
      class="med"
      style={{ background: c().color }}
      title={t(`category.${props.category}`)}
    >
      <Icon name={c().icon} />
    </span>
  );
}
